var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    width: 30,
    height: 30,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,0c8.3,0,15,6.7,15,15s-6.7,15-15,15S0,23.3,0,15S6.7,0,15,0z M15,6.2c-2.8,0-5,2.1-5.4,4.1v4.2c0,0.5,0.1,4,2.4,5.8 l0.6,0.5l-7.5,4.1c2.5,2.5,5.9,4,9.8,4s7.2-1.5,9.8-4l-7.4-4.1l0.6-0.5c2.2-1.8,2.4-5.3,2.4-5.8v-4.2C20,8.3,17.8,6.2,15,6.2z  M15,1.1C7.3,1.1,1.1,7.3,1.1,15c0,3.5,1.2,6.6,3.3,9l6.3-3.5c-2.1-2.2-2.2-5.8-2.2-6.1v-4.2c0-0.1,0-0.1,0-0.1c0.4-2.3,3-4.9,6.2-5 H15c3.4,0,6.1,2.6,6.4,5c0,0.1,0,0.1,0,0.1v4.2c0,0.5-0.1,4-2.2,6.1l6.3,3.5c2.1-2.5,3.4-5.6,3.4-9.1c0-3.7-1.5-7.2-4.1-9.8 S18.7,1.1,15,1.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.4e3597c42f56ab70b2fd0156a7d9f286.svg";
export { ForwardRef as ReactComponent };